import { uuid25 } from "../../uuid/dist/uuid25.js";
import { OrderType } from "../../constants/schema.js";
import { deepMerge } from "../deepMerge.js";
//#region src/utils/collection/indexColumn.entity.ts
var createIndexColumn = (value) => deepMerge({
	id: uuid25(),
	indexId: "",
	columnId: "",
	orderType: OrderType.ASC
}, value ?? {});
//#endregion
export { createIndexColumn };
